import { SHORTCUT_DELIVERY_ZONE_FIELDS } from '@@partner:graphql/shortcuts'
import { DeliveryZone, GeoPoint } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useLazyQuery, useQuery } from '@apollo/client'

export type ZonesInGeoPolygonVariables = {
  corners: GeoPoint[]
} 

export type ZonesInGeoPolygonQuery = {
  zonesInGeoPolygon: DeliveryZone[]
}


export const GQL_QUERY_ZONES_IN_GEO_POLYGON = gql`
  query zonesInGeoPolygon(
    $corners: [GeoPointInput]!
  ) {
    zonesInGeoPolygon(
      corners: $corners
    ) {
      ${SHORTCUT_DELIVERY_ZONE_FIELDS}
      shop {
        id
        name
        address
        shopGeoPoint {
          latitude
          longitude
        }
      }
    }
  }
`

export const useFetchZonesInGeoPolygon = (variables: ZonesInGeoPolygonVariables) => 
  useQuery<ZonesInGeoPolygonQuery, ZonesInGeoPolygonVariables>(GQL_QUERY_ZONES_IN_GEO_POLYGON, {
    variables,
    fetchPolicy: 'network-only'
  })

export const useLazyFetchZonesInGeoPolygon = () => useLazyQuery<ZonesInGeoPolygonQuery, ZonesInGeoPolygonVariables>(GQL_QUERY_ZONES_IN_GEO_POLYGON)